/*
    Add here your own custom javascript
*/


(function () {
  function applyHomepageFeaturedSaleBadges() {
    if (!document.body.classList.contains('page-type-index')) return;
    const sections = document.querySelectorAll('.featured-products, [id*="featured_products"]');
    sections.forEach((section) => {
      section.querySelectorAll('.product-item').forEach((item) => {
        const media = item.querySelector('.l4v-card-media');
        const sale = item.querySelector('.img-badge-sale');
        if (media && sale) {
          if (sale.parentElement !== media) media.appendChild(sale);
          media.style.position = 'relative';
          media.style.overflow = 'hidden';
          sale.style.position = 'absolute';
          sale.style.left = '14px';
          sale.style.bottom = '14px';
          sale.style.top = 'auto';
          sale.style.right = 'auto';
          sale.style.transform = 'none';
          sale.style.zIndex = '8';
          sale.style.margin = '0';
        }
        item.querySelectorAll('.img-badge-custom, .img-badge-stock, .img-badge-sold-out').forEach((badge) => {
          badge.style.display = 'none';
        });
      });
    });
  }

  function applyHomepageHeroAndNewsletterButtons() {
    if (!document.body.classList.contains('page-type-index')) return;
    const selectors = [
      '#carousel-carousel .l4v-hero-btn',
      '#shopify-section-newsletter .input-group > .btn',
      '#shopify-section-footer-group .newsletter .input-group > .btn',
      '#shopify-section-footer .newsletter .input-group > .btn',
      '.newsletter .input-group > .btn'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((btn) => {
      btn.style.backgroundColor = '#e1c55d';
      btn.style.backgroundImage = 'linear-gradient(180deg,#f6e084 0%,#e1c55d 50%,#c9982e 100%)';
      btn.style.boxShadow = '0 10px 22px rgba(118,86,18,.18), inset 0 1px 0 rgba(255,255,255,.34), inset 0 -1px 0 rgba(179,132,30,.16)';
      btn.style.border = 'none';
      btn.style.color = '#6d4d14';
      btn.style.fontWeight = '500';
      btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
    });
  }

  function rerunHomepageFixes() {
    applyHomepageFeaturedSaleBadges();
    applyHomepageHeroAndNewsletterButtons();
  }

  document.addEventListener('DOMContentLoaded', rerunHomepageFixes);
  window.addEventListener('load', rerunHomepageFixes);
  window.addEventListener('resize', rerunHomepageFixes);
  setTimeout(rerunHomepageFixes, 300);
  setTimeout(rerunHomepageFixes, 1200);
  setTimeout(rerunHomepageFixes, 2500);
})();


(function () {
  function l4vSetShown(wrapper, inner, shown, innerDisplay) {
    if (wrapper) {
      wrapper.style.setProperty('display', shown ? 'block' : 'none', 'important');
      wrapper.style.setProperty('visibility', shown ? 'visible' : 'hidden', 'important');
      wrapper.style.setProperty('opacity', shown ? '1' : '0', 'important');
      wrapper.style.setProperty('overflow', shown ? 'visible' : 'hidden', 'important');
      wrapper.style.setProperty('pointer-events', shown ? 'auto' : 'none', 'important');
      if (shown) {
        wrapper.style.removeProperty('height');
        wrapper.style.removeProperty('min-height');
        wrapper.style.removeProperty('max-height');
        wrapper.style.removeProperty('margin-top');
        wrapper.style.removeProperty('margin-bottom');
        wrapper.style.removeProperty('padding-top');
        wrapper.style.removeProperty('padding-bottom');
        wrapper.style.removeProperty('border-top-width');
        wrapper.style.removeProperty('border-bottom-width');
      } else {
        wrapper.style.setProperty('height', '0', 'important');
        wrapper.style.setProperty('min-height', '0', 'important');
        wrapper.style.setProperty('max-height', '0', 'important');
        wrapper.style.setProperty('margin-top', '0', 'important');
        wrapper.style.setProperty('margin-bottom', '0', 'important');
        wrapper.style.setProperty('padding-top', '0', 'important');
        wrapper.style.setProperty('padding-bottom', '0', 'important');
        wrapper.style.setProperty('border-top-width', '0', 'important');
        wrapper.style.setProperty('border-bottom-width', '0', 'important');
      }
    }
    if (inner) {
      inner.style.setProperty('display', shown ? innerDisplay : 'none', 'important');
      inner.style.setProperty('visibility', shown ? 'visible' : 'hidden', 'important');
      inner.style.setProperty('opacity', shown ? '1' : '0', 'important');
      inner.style.setProperty('pointer-events', shown ? 'auto' : 'none', 'important');
      if (!shown) {
        inner.style.setProperty('height', '0', 'important');
        inner.style.setProperty('min-height', '0', 'important');
        inner.style.setProperty('max-height', '0', 'important');
        inner.style.setProperty('margin-top', '0', 'important');
        inner.style.setProperty('margin-bottom', '0', 'important');
        inner.style.setProperty('padding-top', '0', 'important');
        inner.style.setProperty('padding-bottom', '0', 'important');
        inner.style.setProperty('border-top-width', '0', 'important');
        inner.style.setProperty('border-bottom-width', '0', 'important');
      } else {
        inner.style.removeProperty('height');
        inner.style.removeProperty('min-height');
        inner.style.removeProperty('max-height');
        inner.style.removeProperty('margin-top');
        inner.style.removeProperty('margin-bottom');
        inner.style.removeProperty('padding-top');
        inner.style.removeProperty('padding-bottom');
        inner.style.removeProperty('border-top-width');
        inner.style.removeProperty('border-bottom-width');
      }
    }
  }

  function l4vVisibleElement(elements) {
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (!el) continue;
      var cs = window.getComputedStyle(el);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && el.getBoundingClientRect().height > 0) return el;
    }
    return null;
  }

  function syncAllHeaderTopbars() {
    var headerRoot = document.querySelector('.shopify-section-group-header-group');
    if (!headerRoot) return;

    var mobile = window.innerWidth <= 991.98;
    document.documentElement.classList.toggle('l4v-is-mobile', mobile);

    var wrappers = Array.prototype.slice.call(headerRoot.children || []);
    var marqueePairs = [];
    var announcementPairs = [];
    var navbarEls = [];

    wrappers.forEach(function (wrapper) {
      if (!wrapper || wrapper.id === 'l4v-cart-header-overlay') return;
      var marquee = wrapper.matches('.marquee') ? wrapper : wrapper.querySelector('.marquee');
      var announcement = wrapper.matches('.announcement-bar') ? wrapper : wrapper.querySelector('.announcement-bar');
      var navbar = wrapper.querySelector('#navbar-mobile, #navbar-desktop, nav.navbar, .navbar');

      if (marquee) marqueePairs.push({ wrapper: wrapper, inner: marquee });
      if (announcement) announcementPairs.push({ wrapper: wrapper, inner: announcement });
      if (navbar) navbarEls.push(navbar);
    });

    marqueePairs.forEach(function (pair) {
      l4vSetShown(pair.wrapper, pair.inner, mobile, 'block');
    });
    announcementPairs.forEach(function (pair) {
      l4vSetShown(pair.wrapper, pair.inner, !mobile, 'flex');
    });

    var topbar = l4vVisibleElement((mobile ? marqueePairs : announcementPairs).map(function (pair) { return pair.inner; }));
    var navbar = l4vVisibleElement(navbarEls);
    var topbarH = topbar ? Math.round(topbar.getBoundingClientRect().height || 0) : 0;
    var headerH = navbar ? Math.round(navbar.getBoundingClientRect().height || 0) : 0;

    document.documentElement.style.setProperty('--l4v-topbar-1', topbarH + 'px');
    document.documentElement.style.setProperty('--l4v-header-h', headerH + 'px');
  }

  function runL4VFinalFixes() {
    syncAllHeaderTopbars();
  }

  document.addEventListener('DOMContentLoaded', runL4VFinalFixes);
  window.addEventListener('load', function () {
    runL4VFinalFixes();
    window.requestAnimationFrame(runL4VFinalFixes);
    setTimeout(runL4VFinalFixes, 120);
    setTimeout(runL4VFinalFixes, 450);
    setTimeout(runL4VFinalFixes, 1200);
  });
  window.addEventListener('resize', runL4VFinalFixes);
  window.addEventListener('pageshow', runL4VFinalFixes);
  window.addEventListener('focus', runL4VFinalFixes);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) runL4VFinalFixes();
  });
  document.addEventListener('shopify:section:load', runL4VFinalFixes);
  setTimeout(runL4VFinalFixes, 150);
  setTimeout(runL4VFinalFixes, 600);
  setTimeout(runL4VFinalFixes, 1500);
})();

(function () {
  function forceHeaderRefresh() {
    try {
      // Force resize (veel themes hangen hier sticky logic aan)
      window.dispatchEvent(new Event('resize'));

      // Force scroll recalculation
      window.dispatchEvent(new Event('scroll'));

      // Simuleer tab focus gedrag
      window.dispatchEvent(new Event('focus'));

      document.dispatchEvent(new Event('visibilitychange'));

      // Kleine extra repaint trigger
      document.body.offsetHeight;
    } catch (e) {
      console.warn('Header refresh error', e);
    }
  }

  (function () {
  let ran = false;

  function refreshHeaderState() {
    const root = document.documentElement;
    const body = document.body;

    // 1 korte layout flush
    void body.offsetHeight;

    // alleen events die waarschijnlijk echt nodig zijn
    window.dispatchEvent(new Event('resize'));

    // 1 extra repaint-cyclus later nog een keer
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        void body.offsetHeight;
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function runInitialHeaderFix() {
    if (ran) return;
    ran = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        refreshHeaderState();

        // wacht ook even op fonts, maar slechts 1 keer extra
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            requestAnimationFrame(() => {
              refreshHeaderState();
            });
          }).catch(() => {});
        }
      });
    });
  }

  if (document.readyState === 'complete') {
    runInitialHeaderFix();
  } else {
    window.addEventListener('load', runInitialHeaderFix, { once: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      requestAnimationFrame(() => {
        refreshHeaderState();
      });
    }
  });
})();

})();

/* L4V v274B — legacy review autoscroll fallback disabled.
   v273I uses assets/l4v-v135-reviews-autoscroll.js as the single source of truth.
   Keeping this old setInterval active caused duplicate carousel timers. */
